$(document).ready(function () {

    $(".component-image-accordion").each(function () {
        var panels = $(this).find(".content");
        var icons = $(this).find(".controller > i");
        var controllers = $(this).find(".controller");

        // Open first panel.
        $(this).find(".content:first").css("display", "block");
        $(this).find(".controller:first").addClass("open");
        $(this).find(".controller > i:first").removeClass("fa-angle-down");
        $(this).find(".controller > i:first").addClass("fa-angle-up");

        // Set initial desktop image.
        var deskImage = $(this).find(".desktop-image");
        var imgSrc = $(this).find(".content:first").find(".mobile-image").attr("src");
        if (imgSrc && imgSrc != "") {
            deskImage.attr("src", imgSrc);
        } else {
            deskImage.css("display", "none");
        }

        $(this).find(".controller > a").click(function (e) {
            e.preventDefault();

            // Swap open classes.
            controllers.removeClass("open");

            // Switch desktop image.
            var mobileImage = $(this).parent().next().find(".mobile-image").attr("src");
            if (mobileImage && mobileImage != "") {
                deskImage.attr("src", mobileImage);
                deskImage.css("display", "block");
            } else {
                deskImage.attr("src", "");
                deskImage.css("display", "none");
            }

            // Close panels.
            var isOpening = $(this).parent().next().css("display") == "none";
            panels.slideUp();
            icons.each(function () {
                $(this).removeClass("fa-angle-up");
                if (!$(this).hasClass("fa-angle-down")) {
                    $(this).addClass("fa-angle-down");
                }
            });

            // Open selected panel.
            if (isOpening) {
                $(this).parent().next().slideDown();
                $(this).next().removeClass("fa-angle-down");
                $(this).next().addClass("fa-angle-up");
                $(this).parent().addClass("open");
            }
        });
    });
});